import React  from 'react';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';

//*files
import { styled } from '@mui/material/styles';
import cssClasses from "./ExamCard.module.css";
import dotIcon from "../../assets/images/icons/Dot.svg";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

import { useNavigate } from 'react-router-dom';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
  }));


export default function ExamCard({ examObject , studentFormObject}) {
    let navigate = useNavigate();


    function goToExamDetails(_examDetails) {
        navigate(`/home/exams/${_examDetails.examShortName}`)
      }
  return (
    <Grid style={{width: '30rem' , margin:'1rem 4rem' }}  >
          <Item onClick={() => { goToExamDetails(examObject) }}  >
              <div className={cssClasses.examCard}>
                  <div className={cssClasses.examCardFirstRow}>
                      <div className={cssClasses.paddingDiv}>
                          <div className={cssClasses.imageWrapper}>
                              <div className={cssClasses.imageSection}>
                                  <img src={examObject.image} alt="ExamLogo" />
                              </div>
                              <div className={cssClasses.StatusDiv}>
                                {  
                                     studentFormObject.paymentStatus === "done" ?
                                             <div className={cssClasses.statusWrapperGreen}>
                                                <div className={cssClasses.statusTextGreen}>Payment: Done</div>
                                             </div>
                                 :
                                   [ studentFormObject.paymentStatus?
                                           <div className={cssClasses.PaymentStatusDiv}>Payment:{studentFormObject.paymentStatus}</div> 
                                           :
                                             [new Date(examObject.applicationCloseDate) > new Date() ?
                                                    <div className={cssClasses.statusWrapperGreen}>
                                                        <div className={cssClasses.dot}>
                                                            <img src={dotIcon} alt="dot" />
                                                        </div>
                                                        <div className={cssClasses.statusTextGreen}>
                                                            <p>Registration Open</p>
                                                        </div>
                                                    </div>
                                                  :
                                           [
                                                     <div className={cssClasses.statusWrapperRed}>
                                                         <div className={cssClasses.dot}>
                                                             <FiberManualRecordIcon style={{ width: "1rem", height: "1rem", color: "red" }} />
                                                         </div>
                                                         <div className={cssClasses.statusTextRed}>
                                                             <p>Registration Closed</p>
                                                         </div>
                                                     </div>
                                           ] 
                                            ]
                                  ] 
                                }
                              </div>
                          </div>
                          <div className={cssClasses.nameWrapper}>
                              <p className={cssClasses.examName}>{examObject.name}</p>
                              <p className={cssClasses.label}>{examObject.examShortName}</p>
                          </div>
                      </div>
                  </div>
                  <div className={cssClasses.paddingDiv}>
                      <div className={cssClasses.info}>
                          <div className={cssClasses.examDetailsWrapper}>
                              <p className={cssClasses.inputLabel}>Exam Fee</p>
                              <p className={cssClasses.inputValue}>₹ {examObject.fee}</p>
                          </div>
                          <div className={cssClasses.examDetailsWrapper}>
                              <p className={cssClasses.inputLabel}>Exam Date</p>
                              <p className={cssClasses.inputValue}>{examObject.examDate}</p>
                          </div>
                          <div className={cssClasses.examDetailsWrapper}>
                              <p className={cssClasses.inputLabel}>Payment type</p>
                              <p className={cssClasses.inputValue}>{examObject.paymentType === "Both" ? "Online/Offline" : examObject.paymentType}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </Item>
      </Grid>
  )
}
